import { render, staticRenderFns } from "./dc4.vue?vue&type=template&id=1077b4a4"
import script from "./dc4.vue?vue&type=script&lang=js"
export * from "./dc4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports